export const FETCH_CUSTOMER_DETAIL_DATA_INIT =
  'FETCH_CRM/CUSTOMER_DETAIL/DATA_INIT';
export const FETCH_CUSTOMER_DETAIL_DATA_SUCCESS =
  'FETCH_CRM/CUSTOMER_DETAIL/DATA_SUCCESS';
export const FETCH_CUSTOMER_DETAIL_DATA_FAIL =
  'FETCH_CRM/CUSTOMER_DETAIL/DATA_FAIL';
